import http from "@/plugins/http";
import { Address } from "@/models/Address";

export const state = {
  addressResults: [],
  fullAddress: {}
};

export const getters = {
  addressResults: state => {
    return state.addressResults;
  },
  fullAddress: state => {
    return state.fullAddress;
  }
};

export const mutations = {
  SET_ADDRESS_RESULTS(state, results) {
    state.addressResults = results;
  },
  SET_FULL_ADDRESS(state, result){
    state.fullAddress = result;
  }
};

export const actions = {
  async getFullAddress({ dispatch, commit }, searchResultId){
    // dispatch("processLoader/setProcessActive", {}, { root: true });
      try {
      let result = await http.get(`Address/GetFullAddress/${encodeURIComponent(searchResultId)}`);
      commit("SET_FULL_ADDRESS", result.data);
      dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.resolve(result.data);
    } catch (e) {
      let message = "";
      if(!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
    //   dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  async searchAddress({ dispatch, commit }, streetAddress) {
    try {
      if (streetAddress != null && streetAddress.length >= 5) {
        let address = await http.post("Address/ValidateAddress", {
          country: "AU",
          formattedAddress: streetAddress,
          includePaf: true,
          includeListing: true,
          listingType: "both"
        });
        commit("SET_ADDRESS_RESULTS", address.data.results);
        return Promise.resolve(address.data.results);
      }
    } catch (e) {
      let message = "";
      if(!e.response) message = e.message;
      else message = Object.values(e.response.data.errors)[0].toString();
      dispatch(
        "httpResponse/setHttpResponse",
        { text: message, color: "error" },
        { root: true }
      );
    //   dispatch("processLoader/setProcessInactive", {}, { root: true });
      return Promise.reject(e);
    }
  },
  completeAddress({ commit, state }, e) {
    var match = state.addressResults.filter(x => x.formatted_address === e);
    if (match.length > 0) {
      var splitStreetAddress = e.split(" ");
      let addr = new Address();
      addr.suburb = match[0].suburb;
      addr.state = splitStreetAddress[splitStreetAddress.length - 2];
      addr.postCode = match[0].postcode;
      addr.streetAddress = e.substring(0, e.indexOf(","));
      commit("SET_ADDRESS_RESULTS", []);
      return addr;
    }
    return null;
  },
};
